/**
 * Phase 342 — in-memory ETag memo for the portal fetcher.
 *
 * <p>The fetcher sends a known ETag as `If-None-Match` and, on a 304, returns the body
 * stored here instead of re-parsing one that was never sent. Module scope, per tab,
 * gone on reload: reporting responses are tenant-scoped data and have no business
 * outliving the page in any durable store.</p>
 */
interface CacheEntry<T = unknown> {
  etag: string;
  body: T;
  stored_at: number;
}

const cache = new Map<string, CacheEntry>();

export function getEtag(url: string): string | undefined {
  return cache.get(url)?.etag;
}

export function getBody<T = unknown>(url: string): T | undefined {
  return cache.get(url)?.body as T | undefined;
}

export function store<T = unknown>(url: string, etag: string, body: T): void {
  cache.set(url, { etag, body, stored_at: Date.now() });
}

/** Test/cleanup helper — not used in production. */
export function clear(): void {
  cache.clear();
}
